// нормалізація рядка
export function norm(v) {
	return (v || '').toString().trim().toUpperCase();
}

// пошук запису у locationList
export function findLocationRecord(locationList, { city, state, zip }) {
	const nZip = norm(zip);
	if (nZip) {
		const byZip = locationList.find(l => norm(l.zip_code) === nZip);
		if (byZip) return byZip;
	}
	const nCity = norm(city);
	const nState = norm(state);
	if (nCity && nState) {
		const byCityState = locationList.find(
			l => norm(l.city) === nCity && norm(l.state) === nState
		);
		if (byCityState) return byCityState;
	}
	return null;
}
/**
 * Перевіряє, що рядок відповідає шаблону 'YYYY-MM-DD'.
 * @param {string} str - Рядок дати у форматі YYYY-MM-DD.
 * @returns {boolean} true, якщо формат валідний.
 */
function isValidDateFormat(str) {
	return /^\d{4}-\d{2}-\d{2}$/.test(str);
}

/**
 * Перевіряє, що рядок відповідає шаблону 'HH:mm' (00..23:00..59).
 * @param {string} str - Рядок часу у форматі HH:mm.
 * @returns {boolean} true, якщо формат валідний.
 */
function isValidTimeFormat(str) {
	return /^([01]\d|2[0-3]):([0-5]\d)$/.test(str);
}

/**
 * Нормалізує дату/час:
 * - Є дата й валідний час  -> "YYYY-MM-DD HH:mm"
 * - Є дата, часу немає або час невалідний -> "YYYY-MM-DD 00:00"
 * - Нема дати (або дата невалідна) -> null
 *
 * @param {string|null|undefined} date - Очікується YYYY-MM-DD.
 * @param {string|null|undefined} time - Очікується HH:mm, але не обов'язковий.
 * @returns {string|null} Нормалізоване значення або null.
 */
function buildDateTime(date, time) {
	// ❌ Дата відсутня або у неправильному форматі
	if (!date || !isValidDateFormat(date)) return null;

	// ✅ Час відсутній → ставимо 00:00
	if (!time) return `${ date } 00:00`;

	// ✅ Час валідний → використовуємо його
	if (isValidTimeFormat(time)) return `${ date } ${ time }`;

	// ⚠️ Час є, але невалідний (наприклад "When Ready") → трактуємо як відсутній
	return `${ date } 00:00`;
}

export function buildStop(raw, { type, locationList, loadId, index }) {
	const address = raw?.street ?? raw?.address ?? null;
	const city = raw?.city ?? null;
	const state = raw?.start ?? null; // в API "start" = штат (наприклад "OH")
	const zip = raw?.zip ?? null;
	const date = raw?.date ?? null;
	const time = raw?.time ?? null;
	const phone = raw?.phone ?? null;

	const rec = findLocationRecord(locationList, { city, state, zip });

	return {
		app: null,
		company: null,
		date_time: buildDateTime(date, time),
		id: null,
		load_id: loadId ?? null,
		loction: {
			city: city ?? rec?.city ?? null,
			city_id: rec?.city_id ?? null,
			state: state ?? rec?.state ?? null,
			state_id: rec?.state_id ?? null,
			zip_code: zip ?? rec?.zip_code ?? null,
		},
		number: index ?? null,
		phone,
		shipper: null,
		shipper_id: null,
		street: address ?? null,
		type,
	};
}

// формування масиву зупинок
export function buildStops(arr, { type, locationList, loadId }) {
	if (!Array.isArray(arr)) return [];
	return arr.map((raw, i) => buildStop(raw, { type, locationList, loadId, index: i }));
}

// оновлення одного load
export function applyLocationsToLoad(load, extractItem, locationList) {
	const pickups = buildStops(extractItem?.locations_pickup, { type: 0, locationList, loadId: load?.load_id });
	const deliveries = buildStops(extractItem?.locations_delivery, { type: 1, locationList, loadId: load?.load_id });

	return {
		...load,
		pickup: pickups,
		delivery: deliveries,
	};
}

// оновлення всіх loads
export function applyAllLoadsWithLocations(loads, extractedLoads, locationList) {
	return loads.map((load, i) => {
		const item = extractedLoads?.[i];
		return item ? applyLocationsToLoad(load, item, locationList) : load;
	});
}
